import { HttpMethod } from '../../constants';
function replaceBookingId(bookingId: string): string {
  return this.path.replace(':bookingId', bookingId);
}
function returnPath(): string {
  return this.path;
}
export const bookingEndpoints = {
  [HttpMethod.Get]: {
    Booking: {
      path: '/bookings/:bookingId',
      route: replaceBookingId
    },
    BookingInvoices: {
      path: '/bookings/:bookingId/invoices',
      route: replaceBookingId
    },
    AccountPasses: {
      path: '/bookings/:bookingId/account/passes',
      route: replaceBookingId
    }
  },
  [HttpMethod.Patch]: {
    Booking: {
      path: '/bookings/:bookingId',
      route: replaceBookingId
    },
    ManyBookings: {
      path: '/bookings/batch',
      route: returnPath
    },
    BookingTerminationConfirmation: {
      path: '/bookings/:bookingId/termination-confirmation',
      route: replaceBookingId
    },
    CancelBooking: {
      path: '/bookings/:bookingId/cancel',
      route: replaceBookingId
    },
    RejectBooking: {
      path: '/bookings/:bookingId/reject',
      route: replaceBookingId
    }
  },
  [HttpMethod.Post]: {
    TerminateBooking: {
      path: '/bookings/:bookingId/terminate',
      route: replaceBookingId
    },
    BatchTerminateBookings: {
      path: '/bookings/terminate/batch',
      route: returnPath
    },
    Bookings: {
      path: '/bookings',
      route: returnPath
    },
    Subscription: {
      path: '/bookings/:bookingId',
      route: replaceBookingId
    },
    FillPdf: {
      path: '/bookings/:bookingId/document',
      route: replaceBookingId
    },
    BatchRejectBookings: {
      path: '/bookings/reject/batch',
      route: returnPath
    },
    BatchConfirmTermination: {
      path: '/bookings/termination-confirmation/batch',
      route: returnPath
    },
    AdminBookings: {
      path: '/admin/bookings',
      route: returnPath
    }
  },
  [HttpMethod.Put]: {
    BookingAccountVehicles: {
      path: '/bookings/:bookingId/account-vehicles-bookings',
      route: replaceBookingId
    },
    AccountPasses: {
      path: '/bookings/:id/account/passes',
      route: replaceBookingId
    }
  }
};
export default bookingEndpoints;